import axios, { AxiosError } from "axios";

// Base API configuration
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001/api";
const API_TIMEOUT = 60000;

const publicApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: API_TIMEOUT,
});

publicApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (config.headers["Authorization"] === undefined) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    for (const headerName in config.headers) {
      if (config.headers[headerName] === null) {
        delete config.headers[headerName];
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

publicApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error: any | AxiosError) => {
    const errorResponse: string = error?.response?.data || "Error";
    // store.dispatch(
    //   setErrorMessage(error?.response?.data?.error || error.message || "Error")
    // );
    return Promise.reject(JSON.stringify(errorResponse));
  },
);

export default publicApi;
// function transformResponse(
//   arg0: Promise<AxiosResponse<any, any, {}>>
// ):
//   | import("axios").AxiosResponse<any, any, {}>
//   | Promise<import("axios").AxiosResponse<any, any, {}>> {
//   throw new Error("Function not implemented.");
// }
